import { api } from './api';
import { OrderData } from '../components/order/OrderData';

export interface OrderResponse {
  message: string;
  data: {
    order: any;
    order_number: string;
    total_amount?: number;
  };
}

export const orderService = {
  /**
   * Create a new order with customer details.
   */
  async createOrder(orderData: Partial<OrderData>): Promise<OrderResponse> {
    // Transform customer details from camelCase to snake_case
    const customerDetails = orderData.customerDetails;
    const payload: Record<string, unknown> = {
      food_parcel_id: orderData.foodParcel?.id,
      customer_details: {
        is_first_time: customerDetails?.is_first_time,
        adults_count: customerDetails?.adults_count,
        children_count: customerDetails?.children_count,
        first_name: customerDetails?.firstName,
        last_name: customerDetails?.lastName,
        email: customerDetails?.email,
        phone: customerDetails?.phone,
        delivery_method: customerDetails?.delivery_method,
        address_line1: customerDetails?.address,
        suburb: customerDetails?.suburb,
        postcode: customerDetails?.postcode,
        company_name: null,
        address_line2: null,
      },
    };
    // Save parcel day at order creation so it is captured even if user never reaches checkout
    if (orderData.assignedParcelDay?.id != null) {
      payload.parcel_day_id = orderData.assignedParcelDay.id;
    }
    
    console.log('Sending order payload:', JSON.stringify(payload, null, 2));
    console.log('Original customer details:', customerDetails);
    
    const response = await api.post('/v1/orders', payload);
    return response.data;
  },

  /**
   * Update order configuration.
   */
  async updateConfiguration(orderId: number, configuration: any): Promise<any> {
    const response = await api.put(`/v1/orders/${orderId}/configuration`, configuration);
    return response.data;
  },

  /**
   * Get order details.
   */
  async getOrder(orderId: number): Promise<any> {
    const response = await api.get(`/v1/orders/${orderId}`);
    return response.data;
  },

  /**
   * Update customer details.
   */
  async updateCustomerDetails(orderId: number, customerDetails: any): Promise<any> {
    // Transform customer details from camelCase to snake_case
    const payload: Record<string, unknown> = {
      first_name: customerDetails.firstName,
      last_name: customerDetails.lastName,
      email: customerDetails.email,
      phone: customerDetails.phone,
      delivery_method: customerDetails.delivery_method,
      address_line1: customerDetails.address,
      suburb: customerDetails.suburb,
      postcode: customerDetails.postcode,
      company_name: null,
      address_line2: null,
    };
    if (customerDetails.is_first_time !== undefined) {
      payload.is_first_time = Boolean(customerDetails.is_first_time);
    }
    if (customerDetails.adults_count !== undefined) {
      payload.adults_count = customerDetails.adults_count;
    }
    if (customerDetails.children_count !== undefined) {
      payload.children_count = customerDetails.children_count;
    }
    
    const response = await api.put(`/v1/orders/${orderId}/customer-details`, payload);
    return response.data;
  },

  /**
   * Submit the order.
   */
  async submitOrder(orderId: number, checkoutData: any): Promise<any> {
    const response = await api.put(`/v1/orders/${orderId}/submit`, checkoutData);
    return response.data;
  },

  /**
   * Cancel an order (customer-initiated).
   * Backend only allows cancel when status is 'created' or 'on_hold'.
   */
  async cancelOrder(orderId: number): Promise<{ message: string; data?: { order_id: number; order_number: string; status: string } }> {
    const response = await api.put(`/v1/orders/${orderId}/cancel`);
    return response.data;
  },
}; 